// extracted by mini-css-extract-plugin
export default {"description":"descriptionblock_description__J3VIc"};